import type { ReactNode } from 'react';
import type { MeResponse } from '@hearth/shared';
import { Wordmark } from '../Wordmark';
import { linkTo, usePath } from '../router';
import type { Api } from '../api';
import { AccountMenu } from './AccountMenu';
import './app.css';

/** The app pages' frame: the wordmark, who's signed in (their account menu), and the page. Tidy, unlike the landing. */
export function Shell({ me, api, onSignOut, children }: { me?: MeResponse; api?: Api; onSignOut?: () => void; children: ReactNode }) {
  const path = usePath();
  return (
    <div className="shell">
      <header className="topbar">
        <div className="wrap topbar-inner">
          <a href="/app" className="home-link" aria-label="Hearth: your servers"><Wordmark /></a>
          {me && onSignOut && (
            <div className="who">
              {me.admin && (
                <a className="admin-link" aria-current={path === '/app/admin' ? 'page' : undefined} {...linkTo('/app/admin')}>Admin</a>
              )}
              <AccountMenu me={me} name={displayName(me)} api={api} onSignOut={onSignOut} />
            </div>
          )}
        </div>
      </header>
      <main className="wrap page">{children}</main>
    </div>
  );
}

/** The name to show: Discord's display name or username, Google's name, else the email's name. */
export function displayName(me: MeResponse): string {
  return me.displayName ?? me.name ?? me.username ?? me.email?.split('@')[0] ?? 'You';
}
